import { render, staticRenderFns } from "./TransferCreator.vue?vue&type=template&id=54ddfca8&"
import script from "./TransferCreator.vue?vue&type=script&lang=js&"
export * from "./TransferCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports